import React, { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { useTagBadgeColours } from '../../../contexts/TagTypeColourContext';

type TagLike = {
    name?: string | null;
    type?: string | null;
};

type TagBadgeProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
    tag: TagLike;
    showType?: boolean;
    children?: ReactNode;
};

const TagBadge = ({
    tag,
    showType = true,
    children,
    className = '',
    style,
    ...props
}: TagBadgeProps) => {
    const colours = useTagBadgeColours(tag.type);
    const badgeStyle: CSSProperties = {
        backgroundColor: colours.background,
        color: colours.color,
        borderColor: colours.background,
        ...style,
    };

    return (
        <span
            className={`badge-accent ${className}`.trim()}
            style={badgeStyle}
            {...props}
        >
            {children ?? (
                <>
                    {showType && tag.type && <span className="font-semibold mr-1">{tag.type}:</span>}
                    {tag.name}
                </>
            )}
        </span>
    );
};

export default TagBadge;
